export default __webpack_public_path__ + "static/media/rising_logo.2594ec01.png";